
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"49","height":"49","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"fill":"#FFA306","d":"M25.401 3l17.514 8.408L47.241 30.3 35.12 45.45H15.68L3.562 30.3l4.326-18.892z"}}),_c('path',{attrs:{"fill":"#0A294A","d":"M17.132 8.72l16.046-.08 10.067 12.456-3.492 15.612L25.33 43.72l-14.492-6.868L7.19 21.275z"}}),_c('path',{attrs:{"d":"M26.117 18.797l4.268 3.24-6.281 9.496c-.134.199-.78 1.259-1.087 1.44l-3.25 1.698a.863.863 0 01-.94-.027 1.06 1.06 0 01-.433-1.005l.589-3.838c.023-.198.092-.387.199-.55.104-.158.528-.792.64-.968l6.295-9.486zm-6.52 11.018a.126.126 0 00-.121.004.144.144 0 00-.07.107l-.35 2.398 1.663 1.264 2.043-1.139v.019a.138.138 0 00.081-.111.143.143 0 00-.05-.13l-1.637-1.231zm8.663-7.046a.478.478 0 00-.693.13l-4.48 6.754a.556.556 0 00-.087.397c.022.139.095.263.203.344a.473.473 0 00.373.092.495.495 0 00.324-.217l4.481-6.773a.561.561 0 00-.121-.745zm.096-7.308c.324-.492.952-.609 1.407-.26l2.812 2.176c.218.167.366.422.41.708a1.17 1.17 0 01-.17.818L31.457 21 27 17.554z","fill":"#FFF","fill-rule":"nonzero"}})])])
          )
        }
      }
    